// AppRoutes.js
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import NotFound from "../pages/404";
import HomeButton from "../components/HomeButton";
import HeroSection from "../components/sections/Hero";
import AboutSction from "../components/sections/About";
import ServicesSection from "../components/sections/services";
import ClientsSection from "../components/sections/ClientsSection";
import Services from "../pages/Services";
import Portfolio from "../pages/Portfolio";
import YoutubeGallery from "../pages/YoutubeGallery";
import CategoryGallery from "../pages/CategoryGallery";
import SoftwareDevelopment from "../pages/SoftwareDevelopment";
import { AnimatePresence, motion } from "framer-motion";
import Contact from "../components/sections/Contact";
import Works from "../pages/Works";
import PrivacyPolicy from "../pages/PrivacyPolicy";

const PageTransition = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      {children}
    </motion.div>
  );
};

const AppRoutes = () => {
  const location = useLocation();

  return (
    <>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <PageTransition>
                <div className="">
                  <HeroSection />
                  <AboutSction />
                  {/* <TechnologiesSection />
                  <CaseStudiesSection />
                  <CTASection />
                  <DevProcessSection />
                  <TeamSection />
                  <CareersSection /> */}
                  {/* <TestimonialsSection />
                  <BlogSection /> */}
                  {/* <FAQSection /> */}
                  <ServicesSection />
                  <ClientsSection />
                  <Contact />
                </div>
              </PageTransition>
            }
          />

          <Route
            path="*"
            element={
              <PageTransition>
                <NotFound />
              </PageTransition>
            }
          />
          <Route
            path="/Services/:id"
            element={
              <PageTransition>
                <Services />
              </PageTransition>
            }
          />
          <Route
            path="/Works/:id"
            element={
              <PageTransition>
                <Works />
              </PageTransition>
            }
          />
          <Route
            path="/Portfolio"
            element={
              <PageTransition>
                <Portfolio />
              </PageTransition>
            }
          />
          <Route
            path="/youtube-gallery"
            element={
              <PageTransition>
                <YoutubeGallery />
              </PageTransition>
            }
          />
          <Route
            path="/youtube-gallery/:playlistId"
            element={
              <PageTransition>
                <YoutubeGallery />
              </PageTransition>
            }
          />
          <Route
            path="/category-gallery/:categoryId"
            element={
              <PageTransition>
                <CategoryGallery />
              </PageTransition>
            }
          />
          <Route
            path="/software-development"
            element={
              <PageTransition>
                <SoftwareDevelopment />
              </PageTransition>
            }
          />
          <Route
            path="/privacy-policy"
            element={
              <PageTransition>
                <PrivacyPolicy />
              </PageTransition>
            }
          />
        </Routes>
      </AnimatePresence>

      {/* Place HomeButton here so it's always visible on all pages */}
      <HomeButton />
    </>
  );
};

export default AppRoutes;
